import { mapControl } from '@/constants';
import vuexStore from '@/vuex-store';
import Bounds from '@/lib/map-control/Bounds';
const HIGHLIGHT_Z_INDEX = 1000;
const UNHIGHLIGHT_Z_INDEX = 0;
export default class Marker {
    highlightZIndex = HIGHLIGHT_Z_INDEX;
    unhighlightZIndex = UNHIGHLIGHT_Z_INDEX;
    mapControl = mapControl;
    mapControlState = vuexStore.state.mapControl;
    mapControlGetters = vuexStore.getters;
    hubControlMap = null;
    isActive = null;
    mapInstance = null;
    relatedWeight = 0;
    naverMarker = null;
    origin = null;
    // TODO 나중에 속도 개선을 위해 필요함. 잊지 않기 위해 추가. idle 이벤트시 이 부분만 채크하도록 처리.
    // 현재는 idle시 채크하는게 많음. 리팩토링 할 시간이 없어서 일단 기존 로직 사용. 이후 idle시는 boundary만 채크하도록 수정 예정.
    // 20221116 윤태건
    isFinalShowWithoutBoundary = false;
    naver;
    mapMarkerList;
    latLng;
    bounds;
    isLine;
    _line;
    get line() {
        return this._line;
    }
    set line(value) {
        this._line = value;
    }
    type;
    id;
    /**
     * @param naver 네이버 지도 라이브러리
     * @param hubControlMap 지도관제 지도 객체
     */
    constructor(naver, hubControlMap) {
        this.naver = naver;
        this.hubControlMap = hubControlMap;
        this.mapMarkerList = hubControlMap.mapMarkerList;
        this.mapInstance = hubControlMap.mapInstance;
        this.latLng = [];
        this.bounds = Bounds.getInstance(naver, this.mapInstance);
    }
    init(naverMarker) {
        this.naverMarker = naverMarker;
        const [lat, lng,] = this.latLng;
        this.setPosition(new this.naver.maps.LatLng(lat, lng));
        return this;
    }
    get getNaverMarker() {
        return this.naverMarker;
    }
    /**
     * 마커 노출 / 비노출 토글
     * @param mapInstance
     * @returns
     */
    toggleVisibility(mapInstance = null) {
        if (this.isLine) {
            return;
        }
        // 숨길시에만 연관가중치, 활성여부 채크
        if (!mapInstance && (this.relatedWeight > 0 || this.isActive)) {
            return;
        }
        this.setMap(mapInstance);
    }
    getPosition() {
        return this.naverMarker.getPosition();
    }
    setPosition(value) {
        return this.naverMarker.setPosition(value);
    }
    getMap() {
        return this.naverMarker.getMap();
    }
    setMap(param) {
        this.naverMarker.setMap(param);
    }
    setZIndex(param) {
        this.naverMarker.setZIndex(param);
    }
    setIcon(param) {
        this.naverMarker.setIcon(param);
    }
    /**
     * 최상위 위치
     */
    highlight() {
        this.setZIndex(this.highlightZIndex);
        if (this.line) {
            this.line.setZIndex(this.highlightZIndex);
        }
    }
    /**
     * 최상위 위치 제거
     */
    unhighlight() {
        this.setZIndex(this.unhighlightZIndex);
        if (this.line) {
            this.line.setZIndex(this.unhighlightZIndex);
        }
    }
    /**
     * 위치 업데이트
     */
    updatePosition() {
        const { latitude: lat, longitude: lng } = this.naverMarker.origin.location;
        this.setPosition({
            lat,
            lng,
        });
    }
    /**
     * 마커 연관 가중치 조회
     * @returns {Number} 가중치
     */
    getRelatedWeight() {
        if (this.relatedWeight <= 0) {
            this.relatedWeight = 0;
        }
        return this.relatedWeight;
    }
    /**
     * 마커 연관 가중치 증가 / 감소
     * @param isDecrease 감소 여부
     * @returns weight 결과값
     */
    updateRelatedWeight(isDecrease) {
        const markerType = this.type;
        const markerTypeMap = {
            store: '🏠  ',
            worker: '🛵 ',
            drop: '📦 ',
        };
        const consoleText = markerTypeMap[markerType] || '';
        if (this.relatedWeight === undefined) {
            this.relatedWeight = 0;
        }
        if (isDecrease) {
            this.relatedWeight -= 1;
        }
        else {
            this.relatedWeight += 1;
        }
        this.relatedWeight = this.relatedWeight <= 0 ? 0 : this.relatedWeight;
        // eslint-disable-next-line
        console.log(consoleText, String(this.id), this.relatedWeight, isDecrease ? '-' : '+');
        return this.relatedWeight;
    }
    /**
     * 가중치 초기화
     */
    resetRelatedWeight() {
        this.relatedWeight = 0;
    }
    /**
     * 마커 최신화
     */
    // eslint-disable-next-line class-methods-use-this
    updateMarker() {
    }
    /**
     * 마커 비활성
     */
    // eslint-disable-next-line class-methods-use-this, @typescript-eslint/no-unused-vars
    deactivateMarker(...args) {
    }
    /**
     * 마커 활성
     */
    // eslint-disable-next-line class-methods-use-this
    activateMarker() {
    }
    /**
     * 현재 주문 필터 조회
     * @reutrns {Array}
     */
    get selectedOrderFilter() {
        return this.mapControlState.selectedOrderFilter;
    }
}
